import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { LoadingSpinner } from '@/components/feedback/loading-spinner'

interface LoadingContextValue {
  isLoading: boolean
  show: () => void
  hide: () => void
}

const LoadingContext = createContext<LoadingContextValue | undefined>(undefined)

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [count, setCount] = useState(0)
  const isLoading = count > 0

  const show = useCallback(() => setCount((c) => c + 1), [])
  const hide = useCallback(() => setCount((c) => Math.max(0, c - 1)), [])

  return (
    <LoadingContext.Provider value={{ isLoading, show, hide }}>
      {children}
      {isLoading && (
        <div
          role="status"
          aria-label="Cargando"
          className="fixed inset-0 z-[200] flex items-center justify-center bg-background/70 backdrop-blur-sm"
        >
          <div className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-card px-8 py-6 shadow-xl">
            <LoadingSpinner size="lg" />
            <p className="text-sm text-muted-foreground">Cargando…</p>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  )
}

export function useLoading(): LoadingContextValue {
  const context = useContext(LoadingContext)
  if (!context) throw new Error('useLoading must be used within a LoadingProvider')
  return context
}
